<template>
  <el-upload ref="uupload" :accept="accept" class="upload-demo" name="attachment" :list-type="listType" :action="action"
    :with-credentials='true' :headers="headers" :on-success="handleSuccess" :show-file-list="isShowFileList"
    :data="params" :limit="limitt" :on-preview="handlePreview" :on-error="handleError" :on-remove="handleRemove"
    :before-remove="beforeRemove" :before-upload="beforeUpload" :multiple="isMultiple" :on-exceed="handleExceed"
    :file-list="fileList">
    <el-button size="small" type="primary">{{ btnTitle }}</el-button>
    <div slot="tip" class="el-upload__tip">{{ lineTip }}</div>
  </el-upload>
</template>
<script>
import { baseUrlt } from "@/api";
export default {
  props: {
    action: { type: String, default: `${baseUrlt}api/attachment/add` },
    params: { type: Object, default: () => ({}) },
    btnTitle: { type: String, default: '点击上传附件' },
    uploadType: { type: String, default: '' },
    limitt: { type: Number, default: 20 },
    fileFormNameIn: { type: String, default: 'ruleForm' },
    fileFieldNameIn: { type: String, default: 'file' },
    isMultiple: { type: Boolean, default: false },
    // fun: { type: Function, default: () => {} },
  },

  data() {
    return {
      fileList: [],
      fileType: [],
      isCheck: false,
      accept: '',
      checkTip: '',
      lineTip: '',
      fileSize: 20,
      headers: {},
      isShowFileList: true,
      listType: 'text',
    };
  },
  watch: {},
  created() {
    this.headers = { 'token': this.$store.state.userInfo ? this.$store.state.userInfo.userToken : '' }
    if (this.uploadType == 'image') {
      this.isCheck = true;
      this.accept = 'image/*';
      this.fileType = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'pdf', 'JPG', 'JPEG', 'PNG', 'GIF', 'BMP', 'PDF'];
      this.checkTip = '上传图片有误';
      this.listType = 'picture'
      // this.lineTip = "只能上传图片文件"
    }
  },
  computed: {},
  methods: {
    beforeUpload(file) {
      if (this.isCheck) {
        var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
        let arr = this.fileType;
        if (arr.indexOf(testmsg) === -1) {
          this.$message.warning(this.checkTip);
          return false; //return false就可以在格式大小不符后返回，不调用接口
        }
        const isLt2M = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt2M) {
          this.$message.warning(`上传文件大小不能超过${this.fileSize}MB`);
          return false;
        }
      }
    },
    clearFiles() {
      this.$refs.uupload.clearFiles();
    },
    handleSuccess(response, file, fileList) {
      // console.log(response, file, fileList, 111);
      // console.log(112)
      this.$emit('setFileList', response, { fileFormNameIn: this.fileFormNameIn, fileFieldNameIn: this.fileFieldNameIn });
    },
    handleError(err, file, fileList) {
      this.$message.error('上传文件失败！');
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
      this.$emit('delFile', fileList, { fileFormNameIn: this.fileFormNameIn, fileFieldNameIn: this.fileFieldNameIn });
    },
    handlePreview(file) {
      if (file.url) {
        const url = file.url;
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('target', '_blank');
        document.body.appendChild(link);
        link.click();
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 ${this.limitt} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    setRefFileList(fileStr) {
      let files = [];
      if (fileStr) {
        fileStr.split(',').map((item, index) => {
          let xxx = item.split('/')[item.split('/').length - 1];
          files.push({ name: xxx, url: item });
        });
      }
      this.fileList = files
    },
    beforeRemove(file, fileList) {
      if (!this.isCheck) {
        //校验情况不需要弹窗
        return this.$confirm(`确定移除 ${file.name}？`);
      }
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-upload-list__item:focus {
  outline-width: 0;
  background: #f7e5e8;
}

/deep/.el-icon-close-tip {
  color: #de3242;
  background: #a0a0a0ab;
  padding: 2px;
}

</style>
